webpackJsonp([55],{

/***/ "H4F6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-invoice-history-table_e90e5f71fbb40763856643424e682f5e.html";

/***/ }),

/***/ "c6SK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var SubscriptionInvoiceHistoryTable = (function () {
    function SubscriptionInvoiceHistoryTable() {
        this.invoicesList = this.invoicesList.map(function (invoice) {
            var status = invoice.status === 'SUCCESS' ? 'success' : 'fail';
            var errorMessage = status === 'fail' ? invoice.status : '';
            return tslib_1.__assign({}, invoice, { status: status,
                errorMessage: errorMessage });
        });
    }
    SubscriptionInvoiceHistoryTable.prototype.getInvoiceUrl = function (invoiceId) {
        return options.apiDomain + "/subscription/invoice/" + invoiceId;
    };
    return SubscriptionInvoiceHistoryTable;
}());
angular
    .module('animatronApp.SubscriptionInvoiceHistoryTable', [])
    .component('subscriptionInvoiceHistoryTable', {
    bindings: {
        invoicesList: '<'
    },
    controller: SubscriptionInvoiceHistoryTable,
    templateUrl: __webpack_require__("H4F6")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/55-c7c98a0cc108ea8b91f3.min.js